<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">Remarks For Drivers</h5>
      <button
        ref="modalCloseBtn"
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      >
        <i class="bi bi-x-circle"></i>
      </button>
    </div>
    <div class="modal-body">
      <div class="partner-modal-section">
        <div class="partner-modal-info">
          <h5 class="info-heading">
            Total Remarks <span class="item-count">03</span>
          </h5>
          <div class="info-content fixed-height-info">
            <div class="info-row">
              <p class="item-date">27/03/2023</p>
              <h5 class="item-title">
                Partner team is ready to launch this driver for this route as
                early as possible.
              </h5>
            </div>
            <div class="info-row">
              <p class="item-date">27/03/2023</p>
              <h5 class="item-title">
                This vehicle is ready to starts on this route from 5th Feb.
              </h5>
            </div>
            <div class="info-row">
              <p class="item-date">27/03/2023</p>
              <h5 class="item-title">
                This vehicle is ready to starts on this route from 5th Feb.
              </h5>
            </div>
          </div>
        </div>
      </div>
      <div class="partner-modal-section">
        <h5 class="section-heading">Total Remarks</h5>
        <div class="partner-form">
          <form>
            <textarea name="" class="form-control"></textarea>
          </form>
        </div>
      </div>
    </div>
    <div class="modal-footer no-border">
      <button class="btn btn-cancel" data-bs-dismiss="modal" aria-label="Close">
        Close
      </button>
      <button class="btn btn-primary">Save Remark</button>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.partner-modal-info .info-row {
  padding: 12px 15px;
}
</style>
